module.exports = __webpack_public_path__ + "img/new_index_cooperate_bg6.7f631fd4.png";